export const VoucherCodeLightBoxActions = {
    SHOW: 'SHOW',
    HIDE: 'HIDE',
    UPDATE: 'UPDATE',
    UPDATE_CODE: 'UPDATE_CODE',
    INVALID_ACTION: 'INVALID_ACTION',
    VALID_ACTION: 'VALID_ACTION',
    ADD_LOADING: 'ADD_LOADING',
    REMOVE_LOADING: 'REMOVE_LOADING',
};
